<template>
  <div v-if="init.promotion">
    <div class="style-list-item m-2 p-2 d-flex align-items-center">
      {{ init.promotion }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PromotionMessage",
  computed: {
    ...mapGetters(["init"]),
  },
};
</script>

<style scoped lang="scss">
.style-list-item {
  border: 1px solid $text-light-color;
  border-radius: 10px;
  background-color: $light-grey;
}
</style>
